module.exports = __webpack_public_path__ + "static/media/chris-ocean-traits.1af41fe4.png";